import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';
import { dataActions } from '../../../shared/store/data-Slice';
import Slider from "react-slick";
import gov1 from "../../../assets/images/gov1.png"
import gov2 from "../../../assets/images/gov2.png"
import gov3 from "../../../assets/images/gov3.png"
import gov4 from "../../../assets/images/gov4.png"
import gov5 from "../../../assets/images/gov5.png"
import gov6 from "../../../assets/images/gov6.png"
import gov7 from "../../../assets/images/gov7.png"

import darkGov2 from "../../../assets/images/dark-gov2.png"
import darkGov3 from "../../../assets/images/dark-gov3.png"
import darkGov4 from "../../../assets/images/dark-gov4.png"
import darkGov5 from "../../../assets/images/dark-gov5.png"
import darkGov6 from "../../../assets/images/dark-gov6.png"

const GovImages = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const govImgData: any[] = [
        {
            "id": 1,
            "title": "Seal of Maharashtra",
            "file": gov1,
            "link": "https://maharashtra.gov.in/"
        },
        {
            "id": 2,
            "title": "Swachh Bharat",
            "file": theme === "dark" ? darkGov2 : gov2,
            "link": "https://swachhbharatmission.gov.in/"
        },
        {
            "id": 3,
            "title": "Make In India",
            "file": theme === "dark" ? darkGov3 : gov3,
            "link": "https://www.makeinindia.com/"
        },
        {
            "id": 4,
            "title": "Indian Railways",
            "file": theme === "dark" ? darkGov4 : gov4,
            "link": "https://www.indianrail.gov.in/"
        },
        {
            "id": 5,
            "title": "Indian GOV",
            "file": theme === "dark" ? darkGov5 : gov5,
            "link": "https://www.india.gov.in/"
        },
        {
            "id": 6,
            "title": "Digital India",
            "file": theme === "dark" ? darkGov6 : gov6,
            "link": "https://www.digitalindia.gov.in/"
        },
        {
            "id": 7,
            "title": "My Gov",
            "file": gov7,
            "link": "https://www.mygov.in/"
        }
    ]

    const dispatch = useDispatch();
    const arrowRef: any = useRef(null);

    const settings = {
        dots: false,
        variableWidth: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    variableWidth: false,
                    infinite: true,
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    variableWidth: false,
                    infinite: true,
                }
            },
        ]
    }

    const handleLink = (item: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item?.link));
    }
    return (
        <div className="dark:bg-[#0B121A] bg-[#F6F9FC] w-full h-full">
            <div className="w-full pb-[30px] md:pb-[60px] 1xl:pb-[65px] pt-[20px] dark:bg-bgDarkDull bg-white rounded-b-[50px] xlsm:rounded-b-[60px] lg:rounded-b-[80px] xl:rounded-b-[100px] h-full">
                <div className='container w-full h-full'>
                    <Slider className='h-full flex w-full gov-slider' ref={arrowRef} {...settings} >
                        {Array.isArray(govImgData) && govImgData.map((item: any, index: number) => (
                            <Link to={item?.link} onClick={(e) => { handleLink(item); e.preventDefault(); }} target='_blank' key={index} className='border dark:bg-bgDarkDull border-white dark:border-transparent  hover:border-[#E5E5E5] hover:rounded-[14px] focus:border-[#E5E5E5] focus:rounded-[14px] dark:hover:border-[#454545] dark:focus:border-[#454545]'>
                                <img src={item?.file} alt={`${item?.title}`} className='rounded-[14px]' />
                            </Link>
                        ))}
                    </Slider>
                </div>
            </div >

        </div>
    );
};

export default GovImages;